import React, { useState } from 'react'
import { RiCloseFill } from 'react-icons/ri';
import { Nav, NavLink, Bars, NavMenu, NavImg, Menu } from '../../assets/styles/navbarElements'
import styled from 'styled-components';
import logo from '../../assets/images/logo1.svg'

const Navbar = () => {

    const [open, setOpen] = useState(false);

    const Test = styled.div`
        background-color: #0D2538;
        position: fixed;
        top: 0;
        right: 0;
        width: 300px;
        height: 100%;
        flex-flow: column nowrap;
        transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
        z-index: 2;
        transition: all 2s ease-in-out;
    `
    const Cross = styled(RiCloseFill)`
        display: none;
        color: red;
        width: 28px;
        @media screen and (max-width: 768px) {
            display: ${({ open }) => open ? 'block' : 'none'};
            transform: translate(880%, 155%);
            font-size: 1.8rem;
            transition: all 1s ease;
            cursor: pointer;
        }
    `

    return (
        <>
            <Nav>

                <NavImg>
                    <img src={logo} alt='logo' style={{ paddingRight: '30px' }} />
                </NavImg>

                <NavMenu>
                    <NavLink to='/home' activeStyle>Home</NavLink>
                </NavMenu>
                <NavMenu>
                    <NavLink to='/about' activeStyle>About</NavLink>
                </NavMenu>
                <NavMenu>
                    <NavLink to='/projects' activeStyle>Projects</NavLink>
                </NavMenu>
                <NavMenu>
                    <NavLink to='/contact' activeStyle>Contact</NavLink>
                </NavMenu>

                <Test open={open}>
                    <Cross open={open} onClick={() => setOpen(!open)} />
                    <Menu>
                        <NavLink to='/home' activeStyle>Home</NavLink>
                    </Menu>
                    <Menu>
                        <NavLink to='/about' activeStyle>About</NavLink>
                    </Menu>
                    <Menu>
                        <NavLink to='/projects' activeStyle>Projects</NavLink>
                    </Menu>
                    <Menu>
                        <NavLink to='/contact' activeStyle>Contact</NavLink>
                    </Menu>
                </Test>

                <Bars onClick={() => setOpen(!open)} />

            </Nav>
        </>
    )
}

export default Navbar